import intl from 'react-intl-universal';
import { Space, Flex, Button } from "antd";
import Evisit from "../../../libs/Evisit";

const TestDevice = ({onNext}) => {
    var rootPath = (process.env.NODE_ENV === "development") ? process.env.PUBLIC_URL : window.eks_webroot + "/pages/workflows";
    return (
        <Space className="test-device" direction="vertical" size="middle" style={{ display: 'flex' }}>
            <h4 className="align-center">{ intl.get("test_device").d("Test Your Device") }</h4>
            <div className="align-center">
                { intl.get("test_now").d("Would you like to test your device (camera, microphone, etc.) now?") }
            </div>
            <div className="align-center">
                <img src={rootPath + '/static/img/mic.svg'} alt="mic" className="component-icon" />
                <img src={rootPath + '/static/img/audio_out.svg'} alt="audio" className="component-icon" />
                <img src={rootPath + '/static/img/camera.svg'} alt="camera" className="component-icon" />
            </div>
            <div className="align-center">
                { intl.get("test_device_hint").d("This will help you start the appointment on time and without interruption.") }
            </div>
            <Flex justify="flex-end">
                <Space>
                    <Button onClick={() => onNext({})}>
                        {intl.get("skip").d("Skip")}
                    </Button>
                    <Button type="primary" onClick={() => {
                        Evisit.postMessageBackToParent({
                            name: "workflow.test_device"
                        });
                    }}>
                        {intl.get("start_test").d("Start Test")}
                    </Button>
                </Space>
            </Flex>
        </Space>
    );
};

export default TestDevice;